export default __webpack_public_path__ + "static/media/tomato.5bd5cc9e.JPG";